// extracted by mini-css-extract-plugin
export default {"personMatchHeader":"person-match-header_personMatchHeader__cHnGC","buttons":"person-match-header_buttons__+wkKZ"};